import React, { useEffect } from 'react';
import NovaeonMark from '../../components/logo/logo';
import PlayerCafeBrand from '../../components/playerCafeBrand/playerCafeBrand';
import PlayerCafeMark from '../../components/playerCafeMark/playerCafeMark';
import ThemeToggle from '../../components/themeToggle/themeToggle';
import Hero from './pages/hero/hero';
import Overview from './pages/overview/overview';
import Tour from './pages/tour/tour';
import Testimonials from './pages/testimonials/testimonials';
import Download from './pages/download/download';
import Faq from './pages/faq/faq';
import Support from './pages/support/support';
import LegalLinks from './pages/legalLinks/legalLinks';
import { styles } from './styles';

const NAV_LINKS = [
  { label: 'How it works', href: '#tour', isSecondary: true },
  { label: 'FAQ', href: '#faq', isSecondary: true },
  { label: 'Support', href: '#support', isSecondary: false },
];

const FOOTER_LINKS = [
  { label: 'Terms of Use', href: '/legal#terms' },
  { label: 'Privacy Policy', href: '/legal#privacy' },
  { label: 'Support', href: '#support' },
];

const SHOW_TESTIMONIALS = process.env.NODE_ENV !== 'production';

function Header(): JSX.Element {

  return (
    <header style={styles.header}>
      <div style={styles.headerInner}>
        <PlayerCafeBrand href="#top" homeLabel="PlayerCafe, back to top" />
        <nav style={styles.nav}>
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={link.isSecondary ? 'pc-nav-secondary' : undefined}
              style={styles.navLink}
            >
              {link.label}
            </a>
          ))}
          <ThemeToggle />
        </nav>
      </div>
    </header>
  );

}

function Footer(): JSX.Element {

  return (
    <footer style={styles.footer}>
      <div className="pc-gutter" style={styles.footerInner}>
        <div style={styles.footerRow}>
          <a href="https://novaeon.io" style={styles.maker}>
            <NovaeonMark size={22} />
            PlayerCafe is made by Novaeon
          </a>
          <nav style={styles.footerLinks}>
            {FOOTER_LINKS.map((link) => (
              <a key={link.href} href={link.href} style={styles.footerLink}>{link.label}</a>
            ))}
          </nav>
        </div>
        <span style={styles.copyright}>© {new Date().getFullYear()} Novaeon LLC. All rights reserved.</span>
        <p style={styles.recaptcha}>
          This site is protected by reCAPTCHA and the Google{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" style={styles.recaptchaLink}>
            Privacy Policy
          </a>{' '}
          and{' '}
          <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" style={styles.recaptchaLink}>
            Terms of Service
          </a>{' '}
          apply.
        </p>
      </div>
    </footer>
  );

}

export default function PlayerCafe(): JSX.Element {

  useEffect(() => {

    const anchor = window.location.hash.slice(1);

    if (anchor) {
      document.getElementById(anchor)?.scrollIntoView({ behavior: 'instant' });
    }
  }, []);

  return (
    <div style={styles.page}>
      <div className="hero-signature" style={styles.signature} aria-hidden>
        <PlayerCafeMark size="100%" />
      </div>
      <Header />
      <main>
        <Hero />
        <Overview />
        <Tour />
        {SHOW_TESTIMONIALS && <Testimonials />}
        <Download />
        <Faq />
        <Support />
        <LegalLinks />
      </main>
      <Footer />
    </div>
  );

}
